import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  freeToWatchMovies: boolean;
};

const initialState: InitialState = {
  freeToWatchMovies: true,
};

const freeToWatchSlice = createSlice({
  name: "freeToWatchSlice",
  initialState,
  reducers: {
    setFreeToWatchMovies: (state, action: PayloadAction<boolean>) => {
      state.freeToWatchMovies = action.payload;
      return state;
    },
    resetFreeToWatchMovies: (state, action) => {
      state.freeToWatchMovies = true;
      return state;
    },
  },
});

export const { setFreeToWatchMovies, resetFreeToWatchMovies} = freeToWatchSlice.actions;
export default freeToWatchSlice;
